import { Dialog } from '@components/dialog';
import { Box, List, ListItem, Typography } from '@mui/material';
import Loading from '@components/Loading';
import { useQuoteIneligibility } from '@services/ineligibility';

type IneligibilitiesModalProps = {
  isOpen: boolean;
  onCloseModal: () => void;
  quoteId: string;
  policyNumber: string | undefined;
};

export const IneligibilitiesModal: React.FC<IneligibilitiesModalProps> = ({
  isOpen,
  onCloseModal,
  policyNumber,
  quoteId,
}) => {
  const { data: ineligibilityResponse, isPending: isLoading } = useQuoteIneligibility(quoteId);

  return (
    <Dialog
      open={isOpen}
      handleCloseDialog={onCloseModal}
      secondaryBtnAction={onCloseModal}
      secondaryBtnText='Exit'
      title={`Quote #${policyNumber} Ineligibilities`}
    >
      <Box sx={{ margin: '10px 28px 8px' }}>
        {}
        {isLoading ? (
          <Loading />
        ) : !ineligibilityResponse?.items.length ? (
          <Typography
            variant='bodySmall'
            sx={{
              color: 'common.black',
            }}
          >
            No ineligibilities were selected during quote creation. This quote was automatically rejected for another
            reason.
          </Typography>
        ) : (
          <>
            <Typography
              variant='bodySmall'
              sx={{
                color: 'common.black',
              }}
            >
              This quote had the following ineligibilities selected:
            </Typography>
            <List sx={{ listStyleType: 'disc', padding: '5px 0 10px 20px' }}>
              {ineligibilityResponse?.items.map((item) => (
                <ListItem key={item.id} sx={{ display: 'list-item', padding: '0' }}>
                  <Typography
                    variant='bodySmall'
                    sx={{
                      fontWeight: 'bold',
                    }}
                  >
                    {item.ineligibility.description}
                  </Typography>
                </ListItem>
              ))}
            </List>
          </>
        )}
      </Box>
    </Dialog>
  );
};
